import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "order-operational-data",
  "data-cy": "operational-data-container"
}
const _hoisted_2 = { class: "section-header bold" }
const _hoisted_3 = {
  class: "operational-notes-editor",
  "data-cy": "operation-notes-editor"
}
const _hoisted_4 = { class: "operational-notes-content" }
const _hoisted_5 = {
  key: 0,
  class: "notes-content"
}
const _hoisted_6 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_7 = { class: "section-header bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OznButton = _resolveComponent("OznButton")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_object_tree = _resolveComponent("object-tree")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("b", null, "Operational Notes", -1)),
      (_ctx.editing)
        ? (_openBlock(), _createBlock(_component_OznButton, {
            key: 0,
            class: "inline-action",
            label: "Save",
            onClick: _ctx.save
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.editing && _ctx.operationalState.notes)
        ? _withDirectives((_openBlock(), _createBlock(_component_OznButton, {
            key: 1,
            class: "inline-action minimal",
            label: "Edit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEditing = true))
          }, null, 512)), [
            [_vShow, !_ctx.readonly]
          ])
        : _createCommentVNode("", true)
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "order-operational-data__notes" }, null, -1)),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_input, {
        modelValue: _ctx.operationalState.notes,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.operationalState.notes) = $event)),
        ref: "OperationalDataInput"
      }, null, 8, ["modelValue"])
    ], 512), [
      [_vShow, _ctx.editing]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "notes", {}, () => [
        (_ctx.operationalState.notes)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.operationalState.notes), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[9] || (_cache[9] = _createElementVNode("i", null, "No notes ", -1)),
              _withDirectives(_createElementVNode("u", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEditing = true))
              }, "Add Some", 512), [
                [_vShow, !_ctx.readonly]
              ])
            ]))
      ], true)
    ], 512), [
      [_vShow, !_ctx.editing]
    ]),
    _createVNode(_component_object_tree, {
      modelValue: _ctx.operationalState.meta,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.operationalState.meta) = $event)),
        _cache[5] || (_cache[5] = ($event: any) => (_ctx.diff = true))
      ],
      suggestions: [],
      header: "Catalogue metadata",
      label: "Add field",
      "onNode:add": _cache[6] || (_cache[6] = ($event: any) => (_ctx.diff = true)),
      "onNode:remove": _cache[7] || (_cache[7] = ($event: any) => (_ctx.diff = true))
    }, {
      header: _withCtx(({header}) => [
        _createElementVNode("h6", _hoisted_7, _toDisplayString(header), 1),
        _withDirectives(_createElementVNode("button", {
          class: "minimal",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
          style: {"margin-top":"12px","margin-left":"5px"}
        }, "Save", 512), [
          [_vShow, _ctx.diff]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}